import { nesaTestnet } from "app/config/chains";

import type { CirculatingSupplyResponse, SupplyResponse } from "./types";

export const useCirculatingSupplyQuery = (
  supplyResponse?: SupplyResponse,
): { data: CirculatingSupplyResponse | null } => {
  if (!supplyResponse || !supplyResponse.amount) return { data: null };

  const outputDecimals = nesaTestnet.currencies[0].coinDecimals;
  const inputDecimals = "anes" === supplyResponse.amount.denom ? 18 : 6;

  const inputMultiplier = 10n ** BigInt(outputDecimals - inputDecimals);
  const outputMultiplier = 10n ** BigInt(outputDecimals);

  const totalSupply = BigInt(supplyResponse.amount.amount) * inputMultiplier;
  const validatorEmissions = totalSupply - BigInt("1000000000") * outputMultiplier;
  const unlocked = BigInt("170875000") * outputMultiplier;
  const total = (validatorEmissions + unlocked).toString();
  const tenM = BigInt("10000000") * outputMultiplier;
  const airdrop = BigInt("17900000") * outputMultiplier;
  const mainnet = (validatorEmissions + tenM + airdrop).toString();

  return { data: { mainnet, total } };
};
